export const ScheduledActions = ({
  onMarkLaunched,
  onEdit,
  onCancel,
  canManage,
}) => [
  {
    label: "Mark Launched",
    icon: "boat",
    primary: true,
    onClickSingle: onMarkLaunched,
    hidden: () => !canManage,
  },
  {
    label: "Message Customer",
    icon: "messages",
    iconStyle: "solid",
    href: (row) => row.messageUrl,
  },
  {
    label: "View Contract",
    icon: "document",
    href: (row) => row.reservationPath,
    hidden: (row) => !row.belongsToContract,
  },
  {
    label: "View Reservation",
    icon: "document",
    href: (row) => row.reservationPath,
    hidden: (row) => row.belongsToContract,
  },
  {
    label: "Edit Details",
    icon: "edit-square-md",
    onClickSingle: onEdit,
    hidden: () => !canManage,
  },
  {
    label: "Cancel Launch",
    icon: "contract-circle-x",
    danger: true,
    confirm: {
      title: "Cancel this launch?",
      message: (row) =>
        `Are you sure you want to cancel the launch for ${row.contactBoat.name}? This action cannot be undone.`,
      confirmLabel: "Yes, cancel",
    },
    onClickSingle: onCancel,
    hidden: () => !canManage,
  },
]

export const LaunchedActions = ({
  onMarkReturned,
  onMoveToScheduled,
  canManage,
}) => [
  {
    label: "Mark Returned",
    icon: "logout",
    primary: true,
    onClickSingle: onMarkReturned,
    hidden: () => !canManage,
  },
  {
    label: "Message Customer",
    icon: "messages",
    iconStyle: "solid",
    href: (row) => row.messageUrl,
  },
  {
    label: "View Contract",
    icon: "document",
    href: (row) => row.reservationPath,
    hidden: (row) => !row.belongsToContract,
  },
  {
    label: "View Reservation",
    icon: "document",
    href: (row) => row.reservationPath,
    hidden: (row) => row.belongsToContract,
  },
  {
    label: "Move back to Scheduled",
    icon: "calendar-month",
    onClickSingle: onMoveToScheduled,
    hidden: () => !canManage,
  },
]

export const ReturnedActions = ({
  onMoveToScheduled,
  onMoveToLaunched,
  canManage,
}) => [
  {
    label: "Message Customer",
    icon: "messages",
    iconStyle: "solid",
    href: (row) => row.messageUrl,
  },
  {
    label: "View Contract",
    icon: "document",
    href: (row) => row.reservationPath,
    hidden: (row) => !row.belongsToContract,
  },
  {
    label: "View Reservation",
    icon: "document",
    href: (row) => row.reservationPath,
    hidden: (row) => row.belongsToContract,
  },
  {
    label: "Move back to Scheduled",
    icon: "calendar-month",
    onClickSingle: onMoveToScheduled,
    hidden: () => !canManage,
  },
  {
    label: "Move back to Launched",
    icon: "boat",
    onClickSingle: onMoveToLaunched,
    hidden: () => !canManage,
  },
]
